import http from '@/services/http.js';

const JIANYING_API = '/videoapi/jianying';

export const fetchEligibleJianyingOrders = async () => {
  const response = await http.get(`${JIANYING_API}/orders`);
  return Array.isArray(response.data.data) ? response.data.data : [];
};

export const fetchJianyingOrderAutomation = async (clientId) => {
  const response = await http.get(
    `${JIANYING_API}/orders/${encodeURIComponent(clientId)}/automation`,
  );
  return response.data.data;
};

export const processJianyingOrderCrop = async ({
  clientId,
  force = false,
  imageIds,
}) => {
  const response = await http.post(
    `${JIANYING_API}/orders/${encodeURIComponent(clientId)}/images/crop`,
    {
      force,
      ...(Array.isArray(imageIds) ? { image_ids: imageIds } : {}),
    },
  );
  return response.data.data;
};

export const generateJianyingImageAiCaptions = async ({ clientId, images }) => {
  const response = await http.post(`${JIANYING_API}/images/ai-caption/generate`, {
    client_id: clientId,
    images,
  });
  return response.data.data;
};

export const createJianyingJob = async ({
  clientId,
  copyPresetId,
  templateId,
  slotValues,
  preferDeviceId = null,
}) => {
  const response = await http.post(`${JIANYING_API}/jobs`, {
    client_id: clientId,
    copy_preset_id: copyPresetId,
    jianying_template_id: templateId,
    slot_values: slotValues,
    prefer_device_id: preferDeviceId || null,
  });
  return response.data.data;
};

export const fetchJianyingJobs = async (params = {}) => {
  const response = await http.get(`${JIANYING_API}/jobs`, { params });
  const data = response.data.data || {};
  return {
    items: Array.isArray(data.data) ? data.data : [],
    page: Number(data.page) || Number(params.page) || 1,
    limit: Number(data.limit) || Number(params.limit) || 20,
    total: Number(data.total) || 0,
  };
};

export const fetchJianyingJobAttempts = async (jobId) => {
  const response = await http.get(
    `${JIANYING_API}/jobs/${encodeURIComponent(jobId)}/attempts`,
  );
  return Array.isArray(response.data.data) ? response.data.data : [];
};

export const retryJianyingJob = async (jobId, preferDeviceId = null) => {
  const response = await http.post(
    `${JIANYING_API}/jobs/${encodeURIComponent(jobId)}/retry`,
    { prefer_device_id: preferDeviceId || null },
  );
  return response.data.data;
};

export const downloadJianyingJob = async (jobId) => {
  const response = await http.get(`${JIANYING_API}/jobs/${jobId}/download`);
  const downloadUrl = response.data.data?.download_url;
  if (!downloadUrl) {
    throw new Error('服务端未返回下载地址');
  }

  const link = document.createElement('a');
  link.href = downloadUrl;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
};
